// Mapped from AmethystEvent project for better "type" safety
// https://code.amazon.com/packages/AmethystEvents/blobs/c8ac406eb1dbb5b5fbe8dc878c0c5d5e0b9004a4/--/configuration/include/com/zappos/amethyst/website/WebsiteEnums.proto#L85
// Only the ones marty uses have been put here
export const PRODUCT_PAGE = 'PRODUCT_PAGE';
export const SEARCH_PAGE = 'SEARCH_PAGE';
export const CART_PAGE = 'CART_PAGE';
export const LANDING_PAGE = 'LANDING_PAGE';
export const CART_PAGE_MODAL = 'CART_PAGE_MODAL';
export const CHECKOUT_PAGE = 'CHECKOUT_PAGE';
export const COLLECTIONS_PAGE = 'COLLECTIONS_PAGE';
export const COLLECTIONS_LIST_PAGE = 'COLLECTIONS_LIST_PAGE';
